/* eslint-disable arrow-body-style */
/* global G */
import submit from 'lib/hook/model/submit'
import session from 'app/_shared/session'
import { setData } from 'lib/sequence/model/api/set'
import routeComposition from 'trait/composition/route'

/**
 * Read TypeExtension Attribute hook.
 *
 * Attempts to submit the current TypeExtension model.
 *
 * @param {Gaia.AppModule.Spec} obj  the current module composition object
 * @returns {function(...[*]): Promise<*[]>}
 */
const submitTypeExtension = obj => async (...args) => {
  const { user } = session(obj)
  const model = obj[G.MODEL]
  const objState = obj[G.STATE]
  const userId = user.key()

  setData(model, {
    type: 'maintenance',
    status: 50,
    submitter: [userId],
  }, { updateCache: true })

  objState[G.ROUTE] = routeComposition(null, 'index')

  return await submit(obj)(...args)
}

export default submitTypeExtension
